/** Created by azhou on 2019/2/15.*/
<template>
  <div class="d-center">
    <span v-if="leftText" :class="[required ? 'text-danger':'text-white','mr-small']">*</span>
    <div class="d-center" v-if="leftText"><div class="form-left-text" :style="{width:width+'px'}">{{leftText}}</div>：</div>
    <div class="  input-self" v-if="type!=='textarea'" style="text-align:left;">
      <el-popover
        placement="right"
        width="490"
        v-model="visible"
        trigger="click">
          <div class="d-brand">
            <div class="type">
              <div v-for="(item,index) in options" :key="item.type" class="type-item" :class="{'qr':index===i}" @click="i=index;list=item.brand;">{{item.type}}</div>
            </div>
            <div class="d-list">
              <div v-for="item in list" :key="item.id" class="d-list-item" :class="{'active':item.id===target.id}"  @click="inputData(item)">{{item.name}}</div>
            </div>
          </div>
        <el-button slot="reference" size="small" type="primary" :style="target.id?'border-radius: 4px 0 0 4px;':''">{{target.id?target.name:'请选择'}}</el-button>
        <el-button v-if="target.id" @click="inputData('')" slot="reference" size="small" style="margin-left: 0; border-radius: 0 4px 4px 0; padding: 9px 10px; margin-left: -1px;">清空</el-button>
      </el-popover>
      <span class="yls" v-if="valueInside.length > 0">(已选{{valueInside.length }}个)</span>
    </div>
  </div>  
</template>
<script>
  export default {
    name: 'LeftTextBorder',
    props: {
      value: {},
       width: {
        type: Number,
        default:100
      },
      type: {
        type: String,
        default: 'text'
      },
      leftText: {
        type: String,
      },
      required: {
        type: Boolean,
        default: false
      },
      options: {
        type: Array,
        default() {
          return [];
        }
      }
    },
    data(){
      return {
        valueInside: [],
        i:0,
        list:[],
        target:{
          id:'',

        },
        visible: false,
      }
    },
    watch:{
      value: {
        handler(newVal, oldVal) {
         this.clickHandler(newVal)
        },
      }
    },
    mounted() {
       this.clickHandler(this.value)
    },
    methods:{
      //点击事件
      clickHandler(newVal){
        if(!newVal){this.list.push(...this.options[0].brand)};
        this.options.forEach((item,index)=>{
            item.brand.forEach(brand=>{
              if(brand.id===newVal){
                this.list=item.brand;
                this.target=brand;
                this.i=index
              }
            })
          })
      },
      //更新数据
      inputData(value){
        this.target=value;
        this.$emit('input',value.id);
        this.visible = false;
      }
    }
  }
</script>
<style lang="scss" scoped>
  .yls{
    color: #666;
    font-size: 12px;
    margin-left: 12px;
  }
  .narrow{
    input{
      height: 24px!important;
    }
  }
  .smallInput{
    height: 24px!important;
    line-height: 24px!important
  }
  .input-self {
    width: 100%;
    box-sizing: border-box;
    display: block;
    color: #606266;
    flex: 1;
    input,textarea{
      border: 1px solid #dcdfe6;
      padding: 3px 0px;
      appearance: none;
      width: 94%;
      padding: 0 3%;
      border-radius: 3px;
      font-size: 14px;
      line-height: 32px;
      &:focus{
        outline: none;
        border: 1px solid #26a2ff;
      }
    }
    input{height: 31px;}
    textarea{
      height: 80px;
      resize: none;
    }
  }
  .append{
    background-color: #f5f7fa;
    vertical-align: middle;
    display: table-cell;
    position: relative;
    border: 1px solid #dcdfe6;
    border-left: 0;
    font-size: 14px;
    padding: 3px 0;
    border-radius: 4px;
    width: 60px;
    white-space: nowrap;
    height: 24px;
    line-height: 24px;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    text-align: center
  }
  .many{
    cursor: pointer;
    background-color: var(--smtc-color-primary);
    width: 80px;
    height: 30px;
    line-height: 30px;
    border-radius: 4px;
    font-size: 12px;
    color: #fff;
    text-align: center;
  }
    .red{
    color: red;
  }
  .many-input{
    display: flex;
    margin-bottom: 6px;
  }
  .input-self .many-input:last-child{
    margin-bottom: 0;
  }
  .hs{
    color: #eee;
  }
  .groups {
    display: flex;
    flex-wrap: wrap;
  }
  .type{
    width: 80px;
  }
  .d-brand{
    display: flex;
  }
  .type-item{
    background-color: #f5f5f5;
    height: 46px;
    width: 80px;
    line-height: 46px;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
  }
  .qr{
    background-color: #fff;
    position: relative;
  }
  .qr::after{
    content: '';
    position: absolute;
    top: 10px;
    left: 0;
    width: 2px;
    height: 26px;
    background-color: var(--smtc-color-primary);
  }
  .d-list{
    margin-left: 12px;
    width: 80%;
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
    height: max-content;
  }
  .d-list-item{
    line-height: 36px;
    height: 36px;
    display: inline-block;
    cursor: pointer;
    font-size: 12px;
    border-radius: 4px;
    margin-bottom: 8px;
    margin-right: 8px;
    padding: 0 12px;
    border: 1px #eee solid;
  }
  .active{
    background-color: var(--smtc-color-primary);
    color: #fff;
  }
</style>
